import { render, staticRenderFns } from "./BrandNewsDetail.vue?vue&type=template&id=eb86ce32&scoped=true"
import script from "./BrandNewsDetail.vue?vue&type=script&lang=js"
export * from "./BrandNewsDetail.vue?vue&type=script&lang=js"
import style0 from "./BrandNewsDetail.vue?vue&type=style&index=0&id=eb86ce32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb86ce32",
  null
  
)

export default component.exports